import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Table } from 'rsuite'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import EditButton from '../../../components/buttons/editButton/EditButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import { budgetFormat } from '../../../utils/formatterUtil'
import { maskIdCard } from '../../../utils/dataUtil'

export default function ViewFormTableWidget({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  loading,
  enableEdit = false,
  setLoading = () => {},
  onDelete = () => {},
  onEdit = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [schema, setSchema] = useState(_schema)
  const [datas, setDatas] = useState([])
  const [isDeleteConfirm, setIsDeleteConfirm] = useState(false)
  const [deleteData, setDeleteData] = useState()

  useEffect(() => {
    setDatas(_schema.datas || [])
  }, [_schema])

  return (
    <Panel>
      <Row>
        {/* {schema.description && (
          <Col style={{ marginBottom: 15 }}>
            <CustomAlertMessageInfo contents={schema.description} />
          </Col>
        )} */}

        <Table rowKey="id" autoHeight wordWrap={true} data={datas} loading={loading}>
          <Column width={95} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          {schema.columHeaders?.map((item) => {
            let input = schema.objects?.find((e) => e.name == item.name)

            let isNumber = item?.isBudget
            let isTaxId = item?.isTaxId || item.name == 'idCard'
            let isValueDf = input?.type == 'RADIO' || input?.type == 'DOPDOWN'

            return (
              <Column
                minWidth={item?.width || 250}
                flexGrow={1}
                align={isNumber ? 'right' : 'left'}
              >
                <HeaderCell>{item.label}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    var valueObj = rowData.values?.find((e) => e.key == item.name)
                    if (isNumber) {
                      return budgetFormat(valueObj?.value)
                    } else if (isTaxId) {
                      return maskIdCard(valueObj?.value)
                    } else if (isValueDf) {
                      return valueObj?.valueDef
                    } else {
                      return valueObj?.value
                    }
                  }}
                </Cell>
              </Column>
            )
            // if (item.type == 'ADDRESS') {
            //   return (
            //     <Column minWidth={250} flexGrow={1}>
            //       <HeaderCell>ที่อยู่</HeaderCell>
            //       <Cell>
            //         {(rowData) => {
            //           var data = rowData.values?.find((e) => e.name == 'address')

            //           var result = item.subSchemas?.map((e) => {
            //             return (
            //               <div>
            //                 <p>{e.header}: </p>
            //               </div>
            //             )
            //           })

            //           return result
            //         }}
            //       </Cell>
            //     </Column>
            //   )
            // } else {
            //   let isNumber = item.type == 'INPUT_NUMBER'
            //   let isValueDf = item.type == 'RADIO' || item.type == 'DOPDOWN'

            //   return (
            //     <Column minWidth={150} flexGrow={1} align={isNumber ? 'right' : 'left'}>
            //       <HeaderCell>{item.label}</HeaderCell>
            //       <Cell>
            //         {(rowData) => {
            //           var valueObj = rowData.values?.find((e) => e.key == item.name)
            //           if (isNumber) {
            //             return budgetFormat(valueObj?.value)
            //           } else if (isValueDf) {
            //             return valueObj?.valueDef
            //           } else {
            //             return valueObj?.value
            //           }
            //         }}
            //       </Cell>
            //     </Column>
            //   )
            // }
          })}

          {enableEdit && (
            <Column width={250} align="center" fixed="right">
              <HeaderCell>จัดการ</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      <EditButton
                        onClick={() => {
                          onEdit(rowData)
                        }}
                      />
                      <CancelButton
                        icon="trash-o"
                        children="ลบ"
                        onClick={() => {
                          setIsDeleteConfirm(true)
                          setDeleteData(rowData)
                        }}
                      />
                    </>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </Row>

      <ConfirmWidget
        title={`ยืนยัน`}
        show={isDeleteConfirm}
        detail={`ยืนยันการลบ`}
        onCancle={() => {
          setIsDeleteConfirm(false)
          setDeleteData('')
        }}
        onConfirm={() => {
          onDelete(deleteData)
          setIsDeleteConfirm(false)
          setDeleteData('')
        }}
      />
    </Panel>
  )
}
